<template>
  <b-row align-h="between">
    <b-col cols="8">
      <p><b>{{$t('views.firm.show.firmname1')}}:</b> {{ idFirm['firmname1'] }}</p>
      <p><b>{{$t('views.firm.show.firmname2')}}:</b> {{ idFirm['firmname2'] }}</p>
      <p v-if="idFirm.phone"><b>{{$t('views.userdata.form.mobilePhone')}}:</b> <phoneNumberLink :phoneNumber="idFirm.phone"/></p>
      <p v-if="idFirm.city"><b>{{$t('views.firm.show.city')}}:</b> {{ idFirm['city'] }}</p>
      <p v-if="idFirm.nip"><b>{{$t('views.firm.show.nip')}}:</b> {{ idFirm['nip'] }}</p>
      <p v-if="idFirm.street"><b>{{$t('views.firm.show.street')}}:</b> {{ idFirm['street'] }}</p>
      <p v-if="idFirm.streetNumber"><b>{{$t('views.firm.show.streetNumber')}}:</b> {{ idFirm['streetNumber'] }}</p>
      <p v-if="idFirm.placeNumber"><b>{{$t('views.firm.show.placeNumber')}}:</b> {{ idFirm['placeNumber'] }}</p>
      <p v-if="idFirm.postcode"><b>{{$t('views.firm.show.postcode')}}:</b> {{ idFirm['postcode'] }}</p>
      <p v-if="idFirm.province"><b>{{$t('views.firm.show.province')}}:</b> {{ idFirm['province'] }}</p>
      <p v-if="idFirm.regon"><b>{{$t('views.firm.form.regon')}}:</b> {{ idFirm['regon'] }}</p>
      <p v-if="idFirm.krs"><b>{{$t('views.firm.form.krs')}}:</b> {{ idFirm['krs'] }}</p>
      <p v-if="idFirm.userEmail"><b>{{$t('views.agreements.show.email')}}:</b> <a :href="'mailto: ' + idFirm.userEmail"> {{ idFirm.userEmail }}</a></p>
      <p v-if="idFirm.contactEmail"><b>{{$t('views.userdata.form.contactEmail')}}:</b> <a :href="'mailto: ' + idFirm.contactEmail"> {{ idFirm.contactEmail }}</a></p>
      <p v-if="idFirm.mobilePhone"><b>{{$t('views.agreements.show.mobilePhone')}}:</b> <phoneNumberLink :phoneNumber="idFirm.mobilePhone"/></p>
      <p v-if="idFirm.extraInfo"><b>{{$t('views.firm.form.extraInfo')}}:</b> {{idFirm.extraInfo}}</p>
      <p v-if="idFirm.idSalesRepresentative"><b>{{$t('views.userdata.form.idSalesRepresentative')}}:</b> {{idFirm.idSalesRepresentative.name}} {{idFirm.idSalesRepresentative.surname}}</p>
      <div v-if="idFirm.applications.length > 0">
        <p><b>{{$t('views.firm.show.applicationsList')}}:</b></p>
        <ul>
          <li v-for="application in idFirm.applications" :key="application['@id']">
            <a target="_blank" :href="'//' + application.subdomain + '.' +  application.domain.domain">{{ application.subdomain + '.' + application.domain.domain }}</a>
          </li>
        </ul>
      </div>
      <span v-if="idFirm.userDataTags && idFirm.userDataTags.length > 0"><b>{{$t('views.firm.form.tags')}}:</b>
        <span v-for="item in idFirm.userDataTags" :key="item['@id']">
          <b-badge class="ml-2" style="font-size: 12px;">{{ item.idTag.tag }}</b-badge>
        </span>
      </span>
      <p v-if="idFirm.userDataSalesOpportunities && idFirm.userDataSalesOpportunities.length > 0"><b>{{ $t('views.firm.form.idOpportunity') }}</b>:</p>
      <p v-for="(salesOpportunity, salesOpportunityIndex) in idFirm.userDataSalesOpportunities" :key="'salesOpportunity' + salesOpportunityIndex"><i v-b-tooltip.hover :title="$t('views.firm.form.idOpportunity') + ': ' + salesOpportunity.idSalesOpportunity.title" :style="'color: ' + salesOpportunity.idSalesOpportunity.color" class="fa fa-circle fa-lg mr-2"></i>{{salesOpportunity.idSalesOpportunity.title}} {{ $t('global.smFrom') }} {{ $moment(salesOpportunity.createdAt).format('YYYY-MM-DD') }} <span v-if="salesOpportunity.dateTo">{{ $t('global.smTo') }} {{$moment(salesOpportunity.dateTo).format('YYYY-MM-DD')}}</span></p>
      <p v-if="idFirm.userDataStatuses && idFirm.userDataStatuses.length > 0"><b>{{ $t('views.firm.form.idStatus') }}</b>:</p>
      <p v-for="(status, statusIndex) in idFirm.userDataStatuses" :key="'status' + statusIndex"><i v-b-tooltip.hover :title="$t('views.firm.form.idStatus') + ': ' + status.idStatus.title" :style="'color: ' + status.idStatus.color" class="fa fa-circle fa-lg mr-2"></i>{{status.idStatus.title}} {{ $t('global.smFrom') }} {{ $moment(status.createdAt).format('YYYY-MM-DD') }} <span v-if="status.dateTo">{{ $t('global.smTo') }} {{$moment(status.dateTo).format('YYYY-MM-DD')}}</span></p>
    </b-col>
<!--    <b-col cols="auto">-->
<!--      <div class="btn-group">-->
<!--        <button type="button" class="btn btn-link fa fa-file-invoice-dollar fa-lg" v-b-tooltip.hover :title="$t('buttons.createInvoice')" aria-hidden="true" @click="toggleInvoiceCreateModal()"></button>-->
<!--      </div>-->
<!--    </b-col>-->
    <InvoiceModal :id-firm="idFirm['@id']"></InvoiceModal>
  </b-row>
</template>

<script>
import InvoiceModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/InvoiceCreateModal'
import { mapMutations } from 'vuex'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  name: 'FirmData',
  data () {
    return {
      firms: [],
      isAddInvoiceModalVisible: false
    }
  },
  components: {
    PhoneNumberLink,
    InvoiceModal
  },
  props: {
    idFirm: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      toggleInvoiceCreateModal: 'exsbinvoice/createModal/toggleModal'
    })
  }
}
</script>
